//Types
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_TOKEN = "SET_CURRENT_TOKEN";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_MESSAGE_TOKEN = "SET_MESSAGE_TOKEN";